import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const DownloadIcons = (props: SvgProps) => (
  <Svg
    // xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#C0A46F"
      d="m11.998 15.5-3.402-3.412.646-.643 2.3 2.3V5.154h.923v8.591l2.3-2.3.646.643-3.412 3.412Zm-5.31 3.346c-.43 0-.794-.148-1.09-.445a1.485 1.485 0 0 1-.446-1.092v-2.39h.923v2.389c0 .154.065.294.193.423.128.128.269.192.423.192h10.615a.588.588 0 0 0 .423-.192.588.588 0 0 0 .193-.423v-2.39h.923v2.391c0 .431-.149.795-.445 1.092-.297.297-.66.445-1.091.445H6.689Z"
    />
  </Svg>
)
export default DownloadIcons